module.exports = __webpack_public_path__ + "static/media/EE3.a9835db6.PNG";